import { API_URL } from "../../constants/pathConstants"
import { VerifyEmailResponse } from "../types"

class VerifyConnector {
	requestInProgress: boolean = false

	public async verifyEmailRequest(code: string, isInstructor: boolean = false): Promise<boolean> {
		try {
			if (this.requestInProgress) {
				console.log('WARNING - [VerifyConnector] verifyEmailRequest() called while request is in process')
				return false
			} else {
				this.requestInProgress = true
				const urlParams = new URLSearchParams()
				urlParams.append("code", code)

				let headers = new Headers();

				headers.append('Content-Type', 'application/json');
				headers.append('Accept', 'application/json');

				let verifySuccess: boolean = false

				await fetch(`${API_URL}${isInstructor ? 'verify-instructor-email' : 'verify-email'}?${urlParams}`, {
					method: 'GET',
					headers: headers
				})
					.then((res) => res.json())
					.then((data: VerifyEmailResponse) => {
						console.log(data)
						if (data.status && data.status === 'success') {
							verifySuccess = true
						}
					})
					.catch((error) => {
						console.log(error)
					})
				
				this.requestInProgress = false
				return verifySuccess
			}
			// return true
		} catch(err) {
			this.requestInProgress = false
			console.log('[RegisterConnector] - performRegisterRequest() failed')
			console.log(err)
			return false
		}
	}
}

export const verifyConnector: VerifyConnector = new VerifyConnector()